import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import { Alert } from "react-bootstrap";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx";
import Header from "../Header";
import "./index.css";

const ProformaList = () => {
  const tableRef = useRef(null);
  const [proinv, setProinv] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [variant, setVariant] = useState("success");
  const [loadingInvoiceId, setLoadingInvoiceId] = useState(null);
  const [generatedInvoices, setGeneratedInvoices] = useState(() => {
    const stored = localStorage.getItem("generatedInvoices");
    return stored ? JSON.parse(stored) : [];
  });

  // Fetch Proforma Invoice List
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://apiaksharaconnect.aksharafinalytics.in/proinvlist"
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
        setProinv(result.proinvList || []);
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && proinv.length > 0) {
      if (!$.fn.dataTable.isDataTable(tableRef.current)) {
        const table = $(tableRef.current).DataTable({
          responsive: true,
          autoWidth: false,
          destroy: true,
          paging: true,
          pageLength: 10,
          lengthMenu: [10, 25, 50, 100],
        });

        return () => {
          table.destroy(); // Cleanup on unmount
        };
      }
    }
  }, [proinv]);

  // Auto-hide alert after a few seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 4000); // hide after 4 seconds
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Export to Excel
  const exportToExcel = () => {
    if (proinv.length === 0) {
      alert("No data to export!");
      return;
    }

    const filteredData = proinv.map(({ invoice_id, userName, amount, dop }) => ({
      InvoiceNo: invoice_id,
      User: userName,
      Amount: amount,
      Date: dop,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Proforma Invoice");
    XLSX.writeFile(wb, "Pro_INV_List.xlsx");
  };

  // Handle Invoice Generation
  const handleGenerateInvoice = async (item) => {
  setLoadingInvoiceId(item.id); // show loader for this item
  setMessage(null); // reset previous message

    try {
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/invoice/${item.id}`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to generate invoice.");
      }

      setMessage("Invoice generated successfully!");
      setVariant("success");

      const updatedInvoices = [...generatedInvoices, item.id];
    setGeneratedInvoices(updatedInvoices);

    // Save to localStorage
    localStorage.setItem("generatedInvoices", JSON.stringify(updatedInvoices));
      
    } catch (error) {
      setMessage("Error generating invoice. Please try again.");
      setVariant("danger");
    } finally {
    setLoadingInvoiceId(null); // stop loader
  }
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          {message && (
            <Alert variant={variant} className="m-3">
              {message}
            </Alert>
          )}
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Proforma Invoice List</h4>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>INV No.</th>
                    <th>Username</th>
                    <th>File</th>
                    <th>Amount</th>
                    <th>Invoice</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {proinv.length > 0 ? (
                    proinv.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td className="text-danger">{item.invoice_id || "N/A"}</td>
                        <td className="text-primary">{item.userName || "N/A"}</td>
                        <td>
                          {item.path ? (
                            <a  href={`https://apiaksharaconnect.aksharafinalytics.in/${item.path}`} target="_blank" rel="noopener noreferrer" title="Download" >
                              <Button variant="warning" size="sm" className="ms-2">
                                <FontAwesomeIcon icon={faDownload} />
                              </Button>
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>Rs. {item.amount || "N/A"}</td>
                        <td>
                         {!item.pinv ? (
                            <Button variant="info" size="sm" className="ms-2" onClick={() => handleGenerateInvoice(item)} disabled={loadingInvoiceId === item.id || generatedInvoices.includes(item.id)}
                            >
                              {loadingInvoiceId === item.id ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"/> Generating...
                                </>
                              ) : generatedInvoices.includes(item.id) ? (
                                "Generated"
                              ) : (
                                "Generate Invoice"
                              )}
                            </Button>
                          ) : (
                            <a  href={`https://apiaksharaconnect.aksharafinalytics.in/${item.invpath}`} target="_blank" rel="noopener noreferrer" title="Invoice Download" >
                              <Button variant="success" size="sm" className="ms-2">
                                <FontAwesomeIcon icon={faDownload} />
                              </Button>
                            </a>
                          )}

                              

                        </td>
                        <td>{item.dop || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No invoice available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProformaList;
